
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14.064"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.471.117a1.268 1.268 0 011.266 1.267v6.582a.422.422 0 11-.844 0V1.384a.423.423 0 00-.422-.422H2.025a.422.422 0 00-.422.422v10.805a.422.422 0 00.422.422h4.223a.422.422 0 110 .845H2.025a1.268 1.268 0 01-1.267-1.267V1.384A1.268 1.268 0 012.025.117z"}}),_c('path',{attrs:{"d":"M7.439 9.42a.272.272 0 01.326-.267l1.363.272a.27.27 0 01.139.075l2.773 2.773a1.043 1.043 0 010 1.473l-.006.006a1.037 1.037 0 01-1.457.027.315.315 0 01-.057-.075l-2.729-2.729a.268.268 0 01-.075-.139l-.272-1.363a.233.233 0 01-.005-.053zm.62.348l.176.881 2.715 2.715a.263.263 0 01.043.055.483.483 0 00.655-.053l.015-.014a.482.482 0 00.138-.342.493.493 0 00-.146-.352L8.94 9.943zM2.767 3.688a.438.438 0 01.438-.437h2.624a.437.437 0 010 .874H3.206a.437.437 0 01-.438-.436zM8.016 5.438a.438.438 0 01-.437.438H3.206a.437.437 0 010-.874h4.373a.437.437 0 01.438.437zM8.003 7.187a.437.437 0 01-.437.438H3.205a.437.437 0 010-.874h4.36a.437.437 0 01.438.436z"}})])
          )
        }
      }
    